import { getT } from '@/i18n';
/**
 * A CELLASZÍN-PALETTA — a felhasználó választott területszíne.
 *
 * KÖZÖS kliens/szerver modul: a profil szerkesztője, a térkép és a Firestore-
 * szabály ugyanebből a listából dolgozik. A KULCS tárolódik, nem a hexkód,
 * ezért a paletta árnyalatai adatmigráció nélkül finomhangolhatók.
 *
 * A kulcsok kompatibilitási okból maradnak stabilak. A látható színt és a
 * magyar címkét az itt lévő paletta határozza meg.
 */

/**
 * A 64 SZÍN — mind ingyenes (Geri, GRUNDO #105). 16 színcsalád, családonként
 * 4 árnyalat világostól sötétig; a sorrend a választórács sorrendje (soronként
 * két család). A korábbi 16 alap- és 12 Pro-szín kulcsa változatlanul benne
 * van, csak a helye változott, ezért a tárolt választások érvényesek.
 */
export const CELL_COLORS = {
  /* gray */
  silver: { hex: '#C8C8C8', get label() { return getT().colorNames.silver; } },
  pink: { hex: '#7F7F7F', get label() { return getT().colorNames.gray; } },
  graphite: { hex: '#555555', get label() { return getT().colorNames.graphite; } },
  slate: { hex: '#2E2E2E', get label() { return getT().colorNames.anthracite; } },
  /* earth */
  purple: { hex: '#DDC3A1', get label() { return getT().colorNames.beige; } },
  violet: { hex: '#E1A344', get label() { return getT().colorNames.goldenBrown; } },
  green: { hex: '#76462D', get label() { return getT().colorNames.walnut; } },
  espresso: { hex: '#4A2C1D', get label() { return getT().colorNames.espresso; } },
  /* khaki */
  sand: { hex: '#E9DCB0', get label() { return getT().colorNames.sand; } },
  khaki: { hex: '#C3B27A', get label() { return getT().colorNames.khaki; } },
  'olive-drab': { hex: '#8A7F4A', get label() { return getT().colorNames.oliveDrab; } },
  'dark-khaki': { hex: '#5A5232', get label() { return getT().colorNames.darkKhaki; } },
  /* orange */
  peach: { hex: '#FFB27A', get label() { return getT().colorNames.peach; } },
  coral: { hex: '#FF6000', get label() { return getT().colorNames.neonOrange; } },
  indigo: { hex: '#D1712F', get label() { return getT().colorNames.copper; } },
  rust: { hex: '#8A3B12', get label() { return getT().colorNames.rust; } },
  /* red */
  sky: { hex: '#E06E70', get label() { return getT().colorNames.coral; } },
  'neon-red': { hex: '#FD012F', get label() { return getT().colorNames.neonRed; } },
  cyan: { hex: '#CB5043', get label() { return getT().colorNames.brick; } },
  teal: { hex: '#8F3A40', get label() { return getT().colorNames.burgundy; } },
  /* raspberry */
  blush: { hex: '#F4A6C0', get label() { return getT().colorNames.blush; } },
  'hot-pink': { hex: '#FF00A8', get label() { return getT().colorNames.neonPink; } },
  blue: { hex: '#BD505C', get label() { return getT().colorNames.raspberry; } },
  wine: { hex: '#6E1E3A', get label() { return getT().colorNames.wine; } },
  /* magenta */
  orchid: { hex: '#E39BE8', get label() { return getT().colorNames.orchid; } },
  magenta: { hex: '#D100D1', get label() { return getT().colorNames.magenta; } },
  'dark-magenta': { hex: '#8E1C8E', get label() { return getT().colorNames.darkMagenta; } },
  aubergine: { hex: '#4A1A4A', get label() { return getT().colorNames.aubergine; } },
  /* purple */
  lavender: { hex: '#C9A8F5', get label() { return getT().colorNames.lavender; } },
  'electric-purple': { hex: '#7C00FF', get label() { return getT().colorNames.neonPurple; } },
  grape: { hex: '#5A2D91', get label() { return getT().colorNames.grape; } },
  orange: { hex: '#5B4A69', get label() { return getT().colorNames.plum; } },
  /* indigo */
  periwinkle: { hex: '#A5A8F0', get label() { return getT().colorNames.periwinkle; } },
  ultramarine: { hex: '#3F3FD0', get label() { return getT().colorNames.ultramarine; } },
  'royal-indigo': { hex: '#2A2580', get label() { return getT().colorNames.royalIndigo; } },
  'deep-indigo': { hex: '#0D034D', get label() { return getT().colorNames.deepIndigo; } },
  /* blue */
  cornflower: { hex: '#8AB4F8', get label() { return getT().colorNames.cornflower; } },
  'electric-blue': { hex: '#2879FD', get label() { return getT().colorNames.electricBlue; } },
  amber: { hex: '#315F89', get label() { return getT().colorNames.steel; } },
  navy: { hex: '#12305A', get label() { return getT().colorNames.navy; } },
  /* cyan */
  'ice-blue': { hex: '#A8E6F5', get label() { return getT().colorNames.iceBlue; } },
  aqua: { hex: '#00E4FE', get label() { return getT().colorNames.neonCyan; } },
  rose: { hex: '#709EAA', get label() { return getT().colorNames.slate; } },
  'deep-cyan': { hex: '#0E5E6F', get label() { return getT().colorNames.deepCyan; } },
  /* teal */
  'light-teal': { hex: '#7FE0D4', get label() { return getT().colorNames.lightTeal; } },
  'teal-green': { hex: '#12B5A5', get label() { return getT().colorNames.tealGreen; } },
  'dark-teal': { hex: '#0B7A72', get label() { return getT().colorNames.darkTeal; } },
  'deep-teal': { hex: '#064A46', get label() { return getT().colorNames.deepTeal; } },
  /* mint */
  ice: { hex: '#01FEA9', get label() { return getT().colorNames.neonMint; } },
  jade: { hex: '#2FB58A', get label() { return getT().colorNames.jade; } },
  yellow: { hex: '#418D7A', get label() { return getT().colorNames.turquoise; } },
  red: { hex: '#2D5653', get label() { return getT().colorNames.petrol; } },
  /* green */
  'mint-green': { hex: '#9BE7A0', get label() { return getT().colorNames.mintGreen; } },
  'neon-green': { hex: '#01FF1F', get label() { return getT().colorNames.neonGreen; } },
  'deep-green': { hex: '#027501', get label() { return getT().colorNames.deepGreen; } },
  forest: { hex: '#1F4D2B', get label() { return getT().colorNames.forest; } },
  /* lime */
  'acid-green': { hex: '#E3FF00', get label() { return getT().colorNames.acidGreen; } },
  'yellow-green': { hex: '#9ACD32', get label() { return getT().colorNames.yellowGreen; } },
  lime: { hex: '#566F49', get label() { return getT().colorNames.olive; } },
  moss: { hex: '#3B4A2A', get label() { return getT().colorNames.moss; } },
  /* yellow */
  lemon: { hex: '#FFF176', get label() { return getT().colorNames.lemon; } },
  gold: { hex: '#FFD502', get label() { return getT().colorNames.neonGold; } },
  mustard: { hex: '#C9A227', get label() { return getT().colorNames.mustard; } },
  bronze: { hex: '#8C6D1F', get label() { return getT().colorNames.bronze; } },
} as const;

export type CellColor = keyof typeof CELL_COLORS;

/** Every selectable colour, in picker order. */
export const CELL_COLOR_KEYS = Object.keys(CELL_COLORS) as CellColor[];

/** Colours per family in the picker. */
export const CELL_COLOR_FAMILY_SIZE = 4;

/**
 * The ORIGINAL 16 base colours in their original order. Only the alfa persona
 * colour pick (`server/src/alfa/enter.ts`) uses it: that pick is a uid hash
 * over this list, and changing the list would move every alfa's colour.
 */
export const BASE_CELL_COLOR_KEYS = [
  'purple', 'violet', 'indigo', 'blue', 'sky', 'cyan', 'teal', 'green',
  'lime', 'yellow', 'amber', 'orange', 'red', 'rose', 'pink', 'slate',
] as const satisfies readonly CellColor[];
export type BaseCellColor = (typeof BASE_CELL_COLOR_KEYS)[number];

/** The default colour (beige), kept from the original palette. */
export const DEFAULT_CELL_COLOR: CellColor = 'purple';

/**
 * ⚠️ `Object.hasOwn`, NEM az `in` operátor.
 *
 * Az `in` a prototípus-láncot is nézi, ezért például a `toString` tévesen
 * érvényes színnek számítana.
 */
export function isCellColor(value: unknown): value is CellColor {
  return typeof value === 'string' && Object.hasOwn(CELL_COLORS, value);
}

/** Ismeretlen vagy hiányzó értéknél az alapértelmezett színre esik vissza. */
export function cellColorHex(value: unknown): string {
  return isCellColor(value) ? CELL_COLORS[value].hex : CELL_COLORS[DEFAULT_CELL_COLOR].hex;
}

/**
 * A hex CSAK akkor, ha a felhasználó ténylegesen választott — különben `null`.
 *
 * ⚠️ NEM ugyanaz, mint a `cellColorHex()`. Ott a hiányzó érték az
 * alapértelmezett palettaszínt adja, ami a térképen helyes (valamit rajzolni
 * kell), de ott hazugság lenne, ahol a „nem választott" eset MÁS
 * megjelenítést kap — például a rivális-sávnál, amely ilyenkor a saját, régi
 * lila-magenta párosát tartja meg (Geri kérése, 2026-08-29).
 */
export function cellColorHexOrNull(value: unknown): string | null {
  return isCellColor(value) ? CELL_COLORS[value].hex : null;
}
